import React, { Component } from 'react';

import InputMask from 'react-input-mask';

import './style/comboInput.scss';

export default class QuestionData extends Component {
	masks = {
		phone: '(99) 9999-9999',
		cel: '(99) 99999-9999',
	};

	constructor(props) {
		super(props);
		this.state = {
			fieldValue: '{}',
			mainValue: '',
			fields: [],
			phoneMask: this.masks.phone,
		};
		this.handleRemoveField = this.handleRemoveField.bind(this);
		this.handleAddField = this.handleAddField.bind(this);
	}

	componentWillMount() {
		const { valueField, nameField } = this.props;

		if (!valueField) {
			return false;
		}

		const values = (typeof valueField === 'string') ? JSON.parse(valueField) : valueField;
		this.setState({
			mainValue: values[0],
		});

		if (!Object.keys(values).length) {
			return false;
		}

		values.shift();

		values.map((content) => {
			const id = `${nameField}_${Math.random()}`;
			this.setState(prevState => ({
				fields: [...prevState.fields, { name: id, value: content }],
			}));
			return content;
		});

		return true;
	}

	componentDidMount() {
		this.buildResponse();
		const { fieldValue } = this.state;
		const { onGetValueField, nameField } = this.props;
		onGetValueField(
			nameField,
			fieldValue,
		);
	}

	handleAddField = () => {
		const { nameField } = this.props;
		const id = `${nameField}_${Math.random()}`;
		this.setState(prevState => ({
			fields: [...prevState.fields, {
				name: id,
				value: '',
			}],
		}));
	};

	handleRemoveField = (id) => {
		const { fields } = this.state;
		const { onGetValueField, nameField } = this.props;

		const list = fields.filter(item => item.name !== id);

		this.setState({
			fields: [...list],
		}, () => {
			this.buildResponse();
			const { fieldValue } = this.state;
			onGetValueField(nameField, fieldValue, this.fieldIsValid());
		});
	};

	fieldIsValid = () => {
		const { required } = this.props;
		const { mainValue } = this.state;

		if (required && !mainValue) {
			return false;
		}

		return true;
	};

	handleChange = idx => (evt) => {
		const { fields, fieldValue } = this.state;
		const { onGetValueField, nameField } = this.props;

		const newShareholders = fields.map((shareholder) => {
			if (shareholder.name === idx) {
				return { ...shareholder, value: evt.target.value };
			}
			return shareholder;
		});

		this.setState({
			fields: newShareholders,
		});

		if (idx === nameField) {
			this.setState({ mainValue: evt.target.value });
		}

		if (evt.target.name.match(/telefone/)) {
			this.updateMask(evt.target);
		}

		this.buildResponse();
		onGetValueField(
			nameField,
			fieldValue,
		);
	};

	updateMask = (e) => {
		const firsPhoneDigit = parseInt(e.value.substring(5, 6), 10);
		const mask = (firsPhoneDigit === 9) ? this.masks.cel : this.masks.phone;

		this.setState({
			phoneMask: mask,
		});
	};

	buildResponse() {
		const { fields, mainValue } = this.state;
		const finalValues = fields.map(field => field.value);

		finalValues.unshift(mainValue);

		this.setState({ fieldValue: finalValues });
	}

	renderInput = (mask, nameField, classField, placeholderField, mainValue, disabledField) => {
		const { phoneMask } = this.state;

		if (mask === 'phone') {
			return (
				<InputMask
					mask={phoneMask}
					maskChar=" "
					type="text"
					name={`telefone ${nameField}`}
					className={classField}
					placeholder={placeholderField}
					onChangeCapture={this.handleChange(nameField)}
					onChange={this.handleChange(nameField)}
					value={mainValue}
					disabled={disabledField}
				/>
			);
		}

		return (
			<InputMask
				mask={phoneMask}
				maskChar=" "
				type="text"
				name={`telefone ${nameField}`}
				className={classField}
				placeholder={placeholderField}
				onChangeCapture={this.handleChange(nameField)}
				onChange={this.handleChange(nameField)}
				value={mainValue}
				disabled={disabledField}
			/>
		);
	};

	render() {
		const {
			question,
			nameField,
			placeholderField,
			disabledField,
			messageErrorField,
			classField,
			classContainer,
			required,
			mask,
		} = this.props;

		const { fields, mainValue, phoneMask } = this.state;

		return (
			<div className={`component-combo-input ${classContainer}`}>
				<p>
					{question}
					{required ? <span>*Campos de preenchimento obrigatório.</span> : ''}
				</p>

				<div className="container-input mb-2">
					{ mask
						? this.renderInput(
							mask,
							nameField,
							classField,
							placeholderField,
							mainValue,
							disabledField,
						)
						: (
							<input
								type="text"
								name={`telefone ${nameField}`}
								className={classField}
								placeholder={placeholderField}
								onChangeCapture={this.handleChange(nameField)}
								onChange={this.handleChange(nameField)}
								value={mainValue}
								disabled={disabledField}
							/>
						)
					}

					<div className="group-buttons">
						<i
							className="btn btn-plus"
							role="button"
							tabIndex="0"
							rel="noopener noreferrer"
							onClick={this.handleAddField}
							onKeyUp={this.handleAddField}
						/>
					</div>
				</div>

				{!fields ? '' : fields.map((field) => {
					if (mask === 'phone') {
						return (
							<div className="container-input mb-2" key={field.name}>
								<InputMask
									mask={phoneMask}
									type="text"
									className={classField}
									name={`telefone ${field.name}`}
									onChange={this.handleChange(field.name)}
									onKeyUp={this.handleChange(field.name)}
									value={field.value}
								/>
								<div className="group-buttons">
									<i
										className="btn btn-less"
										role="button"
										tabIndex="0"
										rel="noopener noreferrer"
										onKeyUp={this.handleRemoveField.bind}
										onClick={this.handleRemoveField.bind(this, field.name)}
									/>
								</div>
							</div>
						);
					}

					if (mask === 'mobile') {
						return (
							<div className="container-input mb-2" key={field.name}>
								<InputMask
									mask={phoneMask}
									type="text"
									className={classField}
									name={`telefone ${field.name}`}
									onChange={this.handleChange(field.name)}
									onKeyUp={this.handleChange(field.name)}
									value={field.value}
								/>
								<div className="group-buttons">
									<i
										className="btn btn-less"
										role="button"
										tabIndex="0"
										rel="noopener noreferrer"
										onKeyUp={this.handleRemoveField.bind}
										onClick={this.handleRemoveField.bind(this, field.name)}
									/>
								</div>
							</div>
						);
					}

					return (
						<div className="container-input mb-2" key={field.name}>
							<input
								type="text"
								className={classField}
								name={`telefone ${field.name}`}
								onChange={this.handleChange(field.name)}
								onKeyUp={this.handleChange(field.name)}
								value={field.value}
							/>
							<div className="group-buttons">
								<i
									className="btn btn-less"
									role="button"
									tabIndex="0"
									rel="noopener noreferrer"
									onKeyUp={this.handleRemoveField.bind}
									onClick={this.handleRemoveField.bind(this, field.name)}
								/>
							</div>
						</div>
					);
				})}
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	}
}
